import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';

import { CSP_INDEX_ROUTE } from '../components/shared/constants';

const CSPIndexRoute = (
  <Route
    key={CSP_INDEX_ROUTE}
    path={CSP_INDEX_ROUTE}
    handle={{ clientSide: true }}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'csp' */
        '../components/discovery/csp/csp_index'
      )).default,
    })}
  />
);

export default CSPIndexRoute;
